const iconsList = {
  'mobile-call': '/images/icons/mobile-call.svg',
  'mobile-email': '/images/icons/mobile-email.svg',
  'mobile-text': '/images/icons/mobile-text.svg',
  logo: '/images/Arjen_Homes_Logo_White.svg',
  triangle: '/images/icons/icon-triangle.svg',
  arrowRight: '/images/icons/arrow-right-gold.svg',
  arrowRightShort: '/images/icons/arrow-right-gold-short.svg',
  arrowRightWhite: '/images/icons/arrow-right-white.svg',
  playWhite: '/images/icons/play-btn-white.svg',
  mapPin: '/images/icons/map-pin.svg',
  beds: '/images/icons/beds.svg',
  baths: '/images/icons/baths.svg',
  sqft: '/images/icons/sqft.svg',
  tour: '/images/icons/tour.svg',
  expend: '/images/icons/expend.svg',
  dollar: '/images/icons/dollar-symbol.svg',
  garage: '/images/icons/private-garage.svg',
  stairs: '/images/icons/stairs.svg',
  expendWhite: '/images/icons/expand-white.svg',
  listView: '/images/icons/list-view.svg',
  filters: '/images/icons/filters.svg',
  started: '/images/icons/get-started.svg',
  plus: '/images/icons/plus.svg',
  minus: '/images/icons/minus-blue.svg',
};

module.exports = iconsList;



// WEBPACK FOOTER //
// ./src/components/IconsList.js